<mat-card *ngFor="let element of response.dataSource.data.result" class="card">
  <mat-card-content>

    <div class="group">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">    
        <section *ngIf="response.groupCard[i] === 0">
          <p *ngIf="i === 0">TOMADOR</p>
          <p *ngIf="i === 2">CORRETORA</p>
          <ng-container *ngIf="response.typeData[i] === 'string'">
            <p>{{element[name]}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'decimal'">
            <p>{{element[name] | currency : 'R$'}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'date'">
            <p>{{element[name] | date:'dd/MM/yyyy' }}</p>
          </ng-container>
        </section>
      </ng-container>
    </div>
     
    <div class="group">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">    
        <section *ngIf="response.groupCard[i] === 1">
          <p>{{response.nameHeader[i]}}</p>
          <ng-container *ngIf="response.typeData[i] === 'string'">
            <p>{{element[name]}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'decimal'">
            <p>{{element[name] | currency : 'R$'}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'date'">
            <p>{{element[name] | date:'dd/MM/yyyy' }}</p>
          </ng-container>
        </section>
      </ng-container>
    </div>

    <div class="group">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">    
        <section *ngIf="response.groupCard[i] === 2">
          <p>{{response.nameHeader[i]}}</p>
          <ng-container *ngIf="response.typeData[i] === 'string'">
            <p>{{element[name]}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'decimal'">
            <p>{{element[name] | currency : 'R$'}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'date'">
            <p>{{element[name] | date:'dd/MM/yyyy' }}</p>
          </ng-container>
        </section>
      </ng-container>
    </div>

    <div class="group">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">    
        <section *ngIf="response.groupCard[i] === 3">
          <p>{{response.nameHeader[i]}}</p>
          <ng-container *ngIf="response.typeData[i] === 'string'">
            <p>{{element[name]}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'decimal'">
            <p>{{element[name] | currency : 'R$'}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'date'">
            <p>{{element[name] | date:'dd/MM/yyyy' }}</p>
          </ng-container>
        </section>
      </ng-container>
    </div>

    <div class="group">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">    
        <section *ngIf="response.groupCard[i] === 4">
          <p>{{response.nameHeader[i]}}</p>
          <ng-container *ngIf="response.typeData[i] === 'string'">
            <p>{{element[name]}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'decimal'">
            <p>{{element[name] | currency : 'R$'}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'date'">
            <p>{{element[name] | date:'dd/MM/yyyy' }}</p>
          </ng-container>
        </section>
      </ng-container>
    </div>

    <div class="group">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">    
        <section *ngIf="response.groupCard[i] === 5">
          <p>{{response.nameHeader[i]}}</p>
          <ng-container *ngIf="response.typeData[i] === 'string'">
            <p>{{element[name]}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'decimal'">
            <p>{{element[name] | currency : 'R$'}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'date'">
            <p>{{element[name] | date:'dd/MM/yyyy' }}</p>
          </ng-container>
        </section>
      </ng-container>
    </div>

    <div class="group">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">    
        <section *ngIf="response.groupCard[i] === 6">
          <p>{{response.nameHeader[i]}}</p>
          <ng-container *ngIf="response.typeData[i] === 'string'">
            <p>{{element[name]}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'decimal'">
            <p>{{element[name] | currency : 'R$'}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'date'">
            <p>{{element[name] | date:'dd/MM/yyyy' }}</p>
          </ng-container>
        </section>
      </ng-container>
    </div>

    <div class="group">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">    
        <section *ngIf="response.groupCard[i] === 7">
          <p>{{response.nameHeader[i]}}</p>
          <ng-container *ngIf="response.typeData[i] === 'string'">
            <p>{{element[name]}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'decimal'">
            <p>{{element[name] | currency : 'R$'}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'date'">
            <p>{{element[name] | date:'dd/MM/yyyy' }}</p>
          </ng-container>
        </section>
      </ng-container>
    </div>

  </mat-card-content>
  <mat-card-actions>
    <div class="actions__text">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">   
        <span 
          [ngClass]="(element.status===true)?'status__active ':'status__deactivate'"
          *ngIf="name === 'status'"
        > 
          {{element.status === true ? 'Ativo': 'Inativo' }} 
        </span>
        <span *ngIf="name === 'statusCCG'"
          [ngClass]="(element.statusCCGId===1) ? 'td__status-pendente':'' 
          || (element.statusCCGId===2) ? 'td__status-em-processo':'' 
          || (element.statusCCGId===3) ? 'td__status-aprovado':''"
        > 
          {{element.statusCCG}}
        </span>
      </ng-container>
    </div>
    <div class="actions__button">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">   

        <ng-container *ngIf="name === 'cgg-tomador'"> 
          <ng-container *ngFor="let item of response.buttons;">
            <button  
              *ngIf="item.tooltip === 'Visualizar'" 
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip" 
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{item.icon}}.svg">
            </button>
            <button 
            *ngIf="item.tooltip === 'Editar'" 
            mat-button 
            [disabled]="item.disabled" 
            [matTooltip]="item.tooltip" 
            (click)="goToNavigate(item.page, element.id, item.pageParams)"
            >
              <img src="../../../assets/icons/{{item.icon}}.svg">
            </button>
            <button 
              *ngIf="item.tooltip === 'Transmitir'
                && element.statusCCGId !== 2
                && element.statusCCGId !== 3" 
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip" 
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{item.icon}}.svg">
          </button>
          <button 
            *ngIf="item.tooltip === 'Reenviar CCG' && element.statusCCGId !== 1 && element.namePerson !== null " 
            mat-button 
            [disabled]="item.disabled" 
            [matTooltip]="item.tooltip" 
            (click)="toTransmit(element.legalPersonId)"
          >
            <img src="../../../assets/icons/{{item.icon}}.svg">
          </button>
          <button 
            *ngIf="item.tooltip === 'Imprimir-CCG' && element.statusCCGId === 3" 
            mat-button 
            [disabled]="item.disabled" 
            [matTooltip]="item.tooltip" 
            (click)="printDocument(element.legalPersonId)"
          >
            <img src="../../../assets/icons/{{item.icon}}.svg">
          </button>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="name === 'user'"> 
          <ng-container *ngFor="let item of response.buttons;">
            <button 
              *ngIf="item.page !== '' && item.tooltip === 'Visualizar'"
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip" 
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{item.icon}}.svg">
            </button>
            <button 
              *ngIf="item.page !== '' && item.tooltip === 'Editar' && this.actions.includes('put')"
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip" 
              (click)="goToNavigate(item.page, element.id)"
            >
            <img src="../../../assets/icons/{{item.icon}}.svg">
          </button>
            <button 
              *ngIf="item.page === ''"
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip" 
              (click)="resendPassword(element.id)"
            >
              <img src="../../../assets/icons/{{item.icon}}.svg">
            </button>
          </ng-container>
        </ng-container>
        
        <ng-container *ngIf="name === 'insuredActions'"> 
          <ng-container *ngFor="let item of response.buttons;">
            <button 
              *ngIf="item.tooltip === 'Visualizar'"
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip" 
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{item.icon}}.svg">
            </button>
            <button 
              *ngIf="item.tooltip === 'Editar' && this.actions.includes('put')"
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip" 
              (click)="goToNavigate(item.page, element.id)"
            >
            <img src="../../../assets/icons/{{item.icon}}.svg">
          </button>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="name === 'takerActions'"> 
          <ng-container *ngFor="let item of response.buttons;">
            <button 
              *ngIf="item.tooltip === 'Visualizar'"
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip" 
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{item.icon}}.svg">
            </button>
            <button 
              *ngIf="item.tooltip === 'Editar' && this.actions.includes('put')"
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip" 
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{item.icon}}.svg">
            </button>
            <button 
              *ngIf="item.tooltip === 'Renovar Crédito' && element.isDataValidade"
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip" 
              (click)="actionButton(element.id)"
            >
              <img src="../../../assets/icons/{{item.icon}}.svg">
            </button>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="name === 'actions'"> 
          <ng-container *ngFor="let item of response.buttons;">
            <button 
              *ngIf="item.tooltip === 'Visualizar'"
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip" 
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{item.icon}}.svg">
            </button>
            <button 
              *ngIf="item.tooltip === 'Editar' && this.actions.includes('put')"
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip" 
              (click)="goToNavigate(item.page, element.id)"
            >
            <img src="../../../assets/icons/{{item.icon}}.svg">
          </button>
          <button 
          *ngIf="item.tooltip === 'Atualizar Dados' && element.isDataValidade"
          mat-button 
          [disabled]="item.disabled" 
          [matTooltip]="item.tooltip" 
          (click)="secondActionButton(element.id)"
          >
            <img src="../../../assets/icons/{{item.icon}}.svg">
          </button>
          </ng-container>
        </ng-container>

      </ng-container>
    </div>
  </mat-card-actions>
</mat-card>